module.exports = __webpack_public_path__ + "static/media/user-list-edit.760fbe3d.svg";